import {KeypadInfoFreeSpinsState} from '@gongxigames/framework/slot';

export class GameKeypadInfoFreeSpinsState extends KeypadInfoFreeSpinsState {
    protected setSpinTickerText(): void {
        this.view.refreshLeftTicker('');
        this.view.refreshRightTicker(this.module.languageService.get('goodLuck'));
    }
}
